<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>Coordinator Commission Report</h2>
    </div>
    <div class="ibox-content report-box" style="min-height: 125px">
      <div class="row">
        <div class="col-xs-12">
          <div class="m-b-md">
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="all_time"
                name="coordinator_commission_period"
                id="coordinator_commission_period_all_time">

              <label for="coordinator_commission_period_all_time">All Time</label>
            </div>
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="date_range"
                name="coordinator_commission_period"
                id="coordinator_commission_period_range">
              <label for="coordinator_commission_period_range">Date Range</label>
            </div>
          </div>

          <div class="form-group" v-show="periodSelectedIsDateRange">
            <date-range
              v-model="dateRange"
              :max-date="yesterday"
              name="date_range">
            </date-range>
          </div>

          <div class="form-group" :class="{ 'has-error': errors.has('coordinator') }">
            <selectize
              :options="[]"
              :fetch-results="fetchCoordinatorResults"
              v-model="coordinator"
              pre-load="focus"
              placeholder="Search for coordinator..."
              name="coordinator"
              v-validate="'required'">
            </selectize>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox-footer text-right">
      <ladda-button
        :on-click="handleGenerateReport"
        class="btn btn-primary btn-sm">
        <i class="fa fa-cloud-download fa-fw"></i> Download XLS
      </ladda-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { DateRange, Selectize, LaddaButton } from 'components/forms'
  import { Roles } from 'utils/user'
  import { notify } from 'utils'
  import moment from 'moment'

  export default {
    components: {
      DateRange,
      Selectize,
      LaddaButton
    },

    data () {
      return {
        period: 'all_time',
        dateRange: null,
        coordinator: null
      }
    },

    created () {
      this.dateRange = {
        from: moment().startOf('month'),
        to: moment().subtract(1, 'day')
      }
    },

    computed: {
      ...mapGetters('user', ['userOptionsUsingNames']),

      yesterday () {
        return moment().subtract(1, 'day')
      },

      periodSelectedIsDateRange () {
        return this.period === 'date_range'
      },

      generatePayload () {
        return {
          period: this.period,
          coordinator: this.coordinator,
          from: this.dateRange.from,
          to: this.dateRange.to
        }
      }
    },

    methods: {
      ...mapActions('user', ['getUsers']),
      ...mapActions('report', ['generateCoordinatorCommissionReport']),

      /**
       * Fetch coordinators from the API.
       *
       * @return Promise
       */
      fetchCoordinatorResults (name, callback) {
        return this.getUsers({ keywords: name, master: true, roles: [Roles.COORDINATOR] }).then(() => {
          callback(this.userOptionsUsingNames)
        })
      },

      handleGenerateReport () {
        return this.validateAll().then(response => {
          const listenForReportGenerated = () => {
            notify.success('Please wait while we get your download ready.')
          }

          return this.generateCoordinatorCommissionReport(this.generatePayload).then(listenForReportGenerated)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CoordinatorCommissionReport.vue?291c4194